import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
// import productServer from '@/components/productServer'
// import solution from '@/components/solution'
// import about from '@/components/aboutUs'
// import relation from '@/components/relation'


Vue.use(Router)
// const router = new Router();
// router.beforeEach((to,from,next)=> {
//   console.log(to);
//   console.log(from);
//   console.log(next);
// })

export default new Router({
  mode:'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: index,
    //   meta: {
    //     title: "安全充电"
    //   }
    // },
    // {
    //   path: '/index',
    //   name: 'index',
    //   component: index,
    //   meta: {
    //     title: "安全充电"
    //   }
    // },
    // {
    //   path: '/product',
    //   name: 'productServer',
    //   component: productServer,
    //   meta: {
    //     title: "产品与服务"
    //   }
    // },
    // {
    //   path: '/solution',
    //   name: 'solution',
    //   component: solution,
    //   meta: {
    //     title: "解决方案"
    //   }
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: about,
    //   meta: {
    //     title: "关于我们"
    //   }
    // },
    // {
    //   path: '/relation',
    //   name: 'relation',
    //   component: relation,
    //   meta: {
    //     title: "联系我们"
    //   }
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js